/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


// (function() {

// })();
document.addEventListener('DOMContentLoaded', function () {
    // Function to attach interval for each product
    function applyProductIntervals(context = document) {
      context.querySelectorAll('.product-item').forEach(function (item) {
        // avoid duplicate intervals
        if (item.dataset.intervalAttached === 'true') return;
        item.dataset.intervalAttached = 'true';

        setInterval(function () {
          const nameEl = item.querySelector('.productName');
          const colorEl = item.querySelector('.color_name');

          if (nameEl && colorEl) {
            let text = nameEl.innerText.trim();

            // Get text after the last dash
            if (text.includes('-')) {
              text = text.split('-').pop().trim();
            }

            if (text && colorEl.innerText !== text) {
              colorEl.innerText = text;
            }
          }
        }, 500);
      });
    }

    // Run once when page loads
    applyProductIntervals();

    // Watch for newly added products (for infinite scroll)
    const observer = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.matches('.product-item')) {
            applyProductIntervals(node.parentNode);
          }
          // In case entire grid section added
          else if (node.nodeType === 1 && node.querySelectorAll) {
            applyProductIntervals(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });


window.addEventListener('load', function() {
   
  function handleSwatches() {
    document.querySelectorAll('.template-product .product__wrapper__inner .swatch-view-custom-image').forEach(function(swatchView) {
      const swatchItems = swatchView.querySelectorAll('.swatch-view-item');
      const total = swatchItems.length;
 
      if (total > 4) { 
        swatchItems.forEach(function(item, index) { 
          if (index >= 4) {
            item.style.display = 'none'; 
          }
        });
 
        const remaining = total - 4;
        const plusBtn = document.createElement('span');
        plusBtn.classList.add('swatch-plus-btn');
        plusBtn.textContent = `+${remaining}`;
        plusBtn.style.cursor = 'pointer';
        plusBtn.style.marginLeft = '6px';
        plusBtn.style.fontWeight = '500';
 
        swatchItems[3].insertAdjacentElement('afterend', plusBtn);
 
        plusBtn.addEventListener('click', function() {
          swatchItems.forEach(function(item) {
            item.style.display = 'inline-block'; 
          });
          plusBtn.remove();
        });
         

      }
    });
  }
 
  const interval = setInterval(function() {
    const items = document.querySelectorAll('.template-product .product__wrapper__inner .swatch-view-custom-image .swatch-view-item');
    if (items.length > 0) {
      clearInterval(interval);
      handleSwatches();
    }
  }, 500); 
  setTimeout(() => clearInterval(interval), 1000);  
});


document.addEventListener('click', function (e) {
  const thumb = e.target.closest('[data-thumb-link]');
  if (!thumb) return;

  e.preventDefault();

  const mediaId = thumb.getAttribute('data-media-id');
  const slide = document.querySelector(`[data-media-id="${mediaId}"]`);

  if (slide) {
    slide.scrollIntoView({
      behavior: 'smooth',
      inline: 'start',
      block: 'nearest'
    });
  }

  // active thumb class
  document.querySelectorAll('.product__thumb').forEach(t =>
    t.classList.remove('is-active')
  );
  thumb.closest('.product__thumb')?.classList.add('is-active');
});


});


// document.addEventListener('click', function (e) {
//   const button = e.target.closest('.custom_mobile-sliderule .sliderow');
//   if (!button) return;

//   const wrapper = button.closest('.custom_mobile-sliderule');
//   if (!wrapper) return;

//   const panel = wrapper.querySelector('.sliderule__panel');

//   // Same level ke open items close karo
//   const parent = wrapper.parentElement;
//   parent.querySelectorAll('.custom_mobile-sliderule .sliderow.is-open').forEach(item => {
//     if (item !== button) {
//       item.classList.remove('is-open');
//       const w = item.closest('.custom_mobile-sliderule');
//       w?.querySelector('.sliderule__panel')?.classList.remove('is-open');
//     }
//   });

//   // Toggle current
//   button.classList.toggle('is-open');
//   panel?.classList.toggle('is-open');
// });

document.addEventListener('click', function (e) {
  const button = e.target.closest('.custom_mobile-sliderule .sliderow');
  if (!button) return;

  const wrapper = button.closest('.custom_mobile-sliderule');
  if (!wrapper) return;

  const panel = wrapper.querySelector('.sliderule__panel');

  const parent = wrapper.parentElement;

  // close other accordions
  parent.querySelectorAll('.custom_mobile-sliderule .sliderow.is-open').forEach(item => {
    if (item !== button) {
      item.classList.remove('is-open');
      const w = item.closest('.custom_mobile-sliderule');
      const p = w?.querySelector('.sliderule__panel');

      if (p) {
        p.style.height = p.scrollHeight + "px";
        requestAnimationFrame(() => {
          p.style.height = "0px";
        });
      }
    }
  });

  // toggle current
  if (button.classList.contains('is-open')) {
    button.classList.remove('is-open');

    panel.style.height = panel.scrollHeight + "px";
    requestAnimationFrame(() => {
      panel.style.height = "0px";
    });

  } else {
    button.classList.add('is-open');

    panel.style.height = panel.scrollHeight + "px";

    panel.addEventListener('transitionend', () => {
      panel.style.height = "auto";
      panel.style.padding = "5px 0px;";
    }, { once: true });
  }
});

document.addEventListener('click', function(e){
  if(e.target.classList.contains('see-more-btn')){
    const parent = e.target.closest('.fabric-description');
    parent.classList.toggle('expanded');
    e.target.textContent = parent.classList.contains('expanded') ? 'See less' : 'See more';
  }
});
 

document.addEventListener('DOMContentLoaded', () => {
  const nav = document.querySelector('.collection__nav');
  if (!nav) return;
  const offsetTop = nav.offsetTop;
  const desktopQuery = window.matchMedia('(min-width: 750px)'); // Desktop breakpoint
  function handleScroll() {
    if (window.scrollY > offsetTop) {
      nav.setAttribute('data-sticky-state', 'active');
    } else {
      nav.removeAttribute('data-sticky-state');
    }
  }
  function checkScreen(e) {
    if (e.matches) {
      window.addEventListener('scroll', handleScroll);
    } else {
      window.removeEventListener('scroll', handleScroll);
      nav.removeAttribute('data-sticky-state'); // safety remove
    }
  }
  checkScreen(desktopQuery); // initial check
  desktopQuery.addEventListener('change', checkScreen);
});

document.addEventListener('DOMContentLoaded', () => {
  const nav = document.querySelector('.collection__nav');
  if (!nav) return;
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  let lastScrollTop = window.scrollY;
  let offsetTop = nav.getBoundingClientRect().top + window.scrollY;
  function handleScroll() {
    const currentScroll = window.scrollY;
    // Scroll UP only
    if (currentScroll < lastScrollTop && currentScroll > offsetTop) {
      nav.setAttribute('data-sticky-state', 'active');
    } else {
      nav.removeAttribute('data-sticky-state');
    }
    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  }
  function checkScreen(e) {
    if (e.matches) {
      offsetTop = nav.getBoundingClientRect().top + window.scrollY; // recalc
      window.addEventListener('scroll', handleScroll);
    } else {
      window.removeEventListener('scroll', handleScroll);
      nav.removeAttribute('data-sticky-state'); // safety remove
    }
  }
  checkScreen(mobileQuery); // initial run
  mobileQuery.addEventListener('change', checkScreen);
});
/*--------------------(RJ/16/01)--------------------*/

document.addEventListener('DOMContentLoaded', () => { 
  const currentURL = window.location.href;
  const selectors = document.querySelectorAll('li.mobile-footer-menu__item a.mobile-footer-menu__link');
  selectors.forEach(function (selector) {
    const href = selector.getAttribute('href');
    if (href && currentURL.includes(href)) {
      selector.closest('li.mobile-footer-menu__item').classList.add('active');
    }
  });

});


const searchInput = document.querySelector('.searchMobile'); 
if (searchInput) {
  searchInput.addEventListener('focus', () => {
      document.body.classList.add('search-visibled'); 
  }); 
  searchInput.addEventListener('blur', () => { 
    setTimeout(() => {
      document.body.classList.remove('search-visibled'); 
    }, 1500);
  }); 
}


// document.addEventListener("DOMContentLoaded", function () {
//   const dataValue = document.body.getAttribute("data-subscript");
//   const wordsToSubscript = dataValue ? dataValue.split(",").map(w => w.trim()): [];
//   function replaceText(node) {
//     if (node.nodeType === 3) {
//       if (node.parentElement.closest(".customsub")) return;
//       let text = node.nodeValue;
//       wordsToSubscript.forEach(word => {
//         const regex = new RegExp(`\\b${word}\\b`, "gi");
//         text = text.replace(
//           regex,
//           `<span class="customsub">${word}<sup>TM</sup></span>`
//         );
//       });
//       if (text !== node.nodeValue) {
//         const span = document.createElement("span");
//         span.innerHTML = text;
//         node.parentNode.replaceChild(span, node);
//       }
//     }
//     else if (
//       node.nodeType === 1 && node.childNodes &&
//       !["SCRIPT", "STYLE", "NOSCRIPT"].includes(node.tagName)
//     ) {
//       node.childNodes.forEach(child => replaceText(child));
//     }
//   }
//   replaceText(document.body);
// });


document.addEventListener("DOMContentLoaded", function () {
  const dataValue = document.body.getAttribute("data-subscript");
  const wordsToSubscript = dataValue
    ? dataValue.split(",").map(w => w.trim())
    : [];
  function replaceText(node) {
    // Text node
    if (node.nodeType === 3) {
      //if (node.parentElement?.closest(".customsub")) return;

      if (node.parentElement?.closest(".customsub") ||node.parentElement?.closest(".product__description__content")) return;

      let text = node.nodeValue;
      wordsToSubscript.forEach(word => {
        // ❗ exact word match, no hyphen before or after
        const regex = new RegExp(`(?<!-)\\b${word}\\b(?!-)`, "gi");
        text = text.replace(
          regex,
          match =>
            `<span class="customsub">${match}<sup>TM</sup></span>`
        );
      });
      if (text !== node.nodeValue) {
        const span = document.createElement("span");
        span.innerHTML = text;
        node.parentNode.replaceChild(span, node);
      }
    }
    // Element node
    else if (
      node.nodeType === 1 &&
      node.childNodes &&
      !["SCRIPT", "STYLE", "NOSCRIPT"].includes(node.tagName)
    ) {
      node.childNodes.forEach(child => replaceText(child));
    }
  }
  replaceText(document.body);
});




document.addEventListener("DOMContentLoaded", () => {
  const slides = document.querySelectorAll(".product__slide");
  const counterEl = document.querySelector(".product__slide-counter .slide-counter");

  if (!slides.length || !counterEl) return;

  const scrollContainer = slides[0].parentElement;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const counter = entry.target.getAttribute("slide-counter");
          if (counter) {
            counterEl.textContent = counter;
          }
        }
      });
    },
    {
      root: scrollContainer,   // 👈 horizontal scroll container
      threshold: 0.6           // 👈 60% slide visible = active
    }
  );

  slides.forEach(slide => observer.observe(slide));
});
